import { ReactElement } from "react"

import { ValidationSection } from "interfaces/markets"
import { sectionStyles } from "../../../../constants/validation"

interface Props {
  section: ValidationSection
  onClick: (value: number) => void
  isSelected: boolean
  count: number
}

const ValidationTab = ({ section, onClick, isSelected, count }: Props): ReactElement => {
  const color = count === 0 ? "gray" : section.color

  return (
    <div
      aria-hidden
      onClick={() => onClick(section.statusId)}
      className={`p-1.5 px-2 cursor-pointer border border-solid border-gray-200 first:rounded-tl-md last:rounded-tr-md border-r-0 last:border-r-2 min-w-[140px] text-center
        ${sectionStyles.text[color]} ${isSelected ? sectionStyles.bg[color] : ""}`}
    >
      <p className="font-bold">
        {section.label} <span className="text-xs">({count})</span>
      </p>
    </div>
  )
}

export default ValidationTab
